<script setup>
import { computed, ref } from 'vue'
import IlluminatedButton from '@/components/buttons/IlluminatedButton.vue'
import OutlineButton from '@/components/buttons/OutlineButton.vue'


const props = defineProps({
    buttonLabel: String,
    buttonLink: String,
    buttonType: {
        type: String,
        default: 'illuminated'
    },
})

// Map buttonType to component
const buttonComponents = {
    illuminated: IlluminatedButton,
    outline: OutlineButton,
}

const ButtonComponent = computed(() => {
    return buttonComponents[props.buttonType] || IlluminatedButton
})

const buttonRef = ref(null)

</script>

<template>
 
  <div ref="buttonRef" class="button-container">
    <component
        v-if="buttonLabel"
        :is="ButtonComponent"
        :label="buttonLabel"
        :link="buttonLink"
    />
  </div>
  
</template>

<style lang="scss" scoped>
.button-container{
  margin: 50px auto;
  width: fit-content;
}


</style>